import { Text, VStack } from '@gazin/ecommerce-ui'
import React from 'react'

type SectionTitleProps = {
  title: string
  subtitle?: string
  darkTheme?: boolean
}

export const SectionTitle = ({
  title,
  subtitle,
  darkTheme,
}: SectionTitleProps) => {
  return (
    <VStack mb={{ base: '1rem', md: '2rem' }}>
      <Text
        as="h2"
        color={darkTheme ? 'neutral.0' : 'neutral.800'}
        fontSize={{ base: '1rem', md: '2rem' }}
        fontWeight="600"
        textAlign="center"
        lineHeight={{ base: '120%', md: '130%' }}
        letterSpacing={0}
      >
        {title}
      </Text>

      {subtitle && (
        <Text
          as="p"
          color={darkTheme ? 'neutral.0' : 'neutral.600'}
          fontSize={{ base: '.875rem', md: '1.125rem' }}
          fontWeight="400"
          textAlign="center"
          lineHeight={{ base: '130%', md: '150%' }}
          w={{ base: '86%', md: '100%' }}
          mt={{ base: '0.5rem', md: '0.875rem' }}
        >
          {subtitle}
        </Text>
      )}
    </VStack>
  )
}
